// Any plugins you want to use has to be imported
// Detail plugins list see https://www.tinymce.com/docs/plugins/
// Custom builds see https://www.tinymce.com/download/custom-builds/

let configure = {};

configure.plugins = ["code "];

configure.toolbar =
  "undo code | forecolor backcolor bold italic underline strikethrough   fontsizeselect ";

configure.fontsize = "10px 12px 14px 16px 18px 24px 36px 48px 56px 72px";

configure.fontfamily =
  "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;默认字体=-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', SimSun, sans-serif, SimSun;Book Antiqua=book antiqua,palatino;";

export default configure;
